import { I18n } from '@calendly/i18n'
import { uniqBy } from 'lodash-es'
import { nanoid } from 'nanoid'

import { EXTERNAL, INTERNAL } from './constants'

export const getOptionNames = () => ({
  [INTERNAL]: I18n.t('publisher.event_type_editor.sections.more_options.confirmation_page.helper_text'),
  [EXTERNAL]: I18n.t('publisher.event_types.confirmation_page.type.external')
})

export const reorderLinks = (links, items) => {
  const findNewIndex = (link) => items.findIndex((item) => item.id === link.id)
  const newOrder = items.slice().sort((a, b) => findNewIndex(a) - findNewIndex(b))

  const newOrderForShownItems = newOrder.map((link, index) => ({
    ...link,
    position: index
  }))

  return uniqBy([...newOrderForShownItems, ...links], 'id')
}

export const generateBlankCustomLink = (position) => ({
  id: `new${nanoid(4)}`,
  enabled: true,
  content: '',
  url: '',
  position,
})
